import { Checkbox, Collapse, IconButton } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PickupInfo from "./PickupInfo";
import clsx from "clsx";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";

class SolutionInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  openDriver = (val) => {
    this.setState({ expanded: !val });
  };

  render() {
    const {
      classes,
      driverAssignment,
      onDriverSelection,
      selectedPickupId,
      onPickupSelection,
      isSelected,
    } = this.props;
    const { expanded } = this.state;
    const totalLength = driverAssignment.pickupIds.length;
    const totalSelected = driverAssignment.pickupIds.filter((pickup) =>
      selectedPickupId.includes(pickup)
    ).length;
    return (
      <div className={classes.solutionContainer}>
        <div
          style={{ borderLeft: `4px solid ${driverAssignment.color}` }}
          className={classes.solutionMainContainer}
        >
          <div className={classes.checkBoxContainer}>
            <Checkbox
              classes={{
                root: classes.checkBoxStyle,
              }}
              color="primary"
              checked={isSelected && totalLength === totalSelected}
              onChange={(e) =>
                onDriverSelection(e, {
                  driverId: driverAssignment.driverId,
                  pickupIds: driverAssignment.pickupIds,
                })
              }
              indeterminate={totalSelected > 0 && totalSelected < totalLength}
              icon={<CheckBoxOutlineBlankIcon className={classes.sizeIcon} />}
              checkedIcon={<CheckBoxIcon className={classes.sizeIcon} />}
              indeterminateIcon={
                <IndeterminateCheckBoxIcon className={classes.sizeIcon} />
              }
            />
            <div>
              <div className={classes.newDriverClass}>NEW DRIVER</div>
              <div className={classes.headerLabelStyle}>
                {`${driverAssignment.driverName} (${driverAssignment.driverNumber})`}
              </div>
            </div>
          </div>
          <div>
            <div className={classes.newDriverClass}>Occ. Capacity</div>
            <div
              className={classes.headerLabelStyle}
            >{`${driverAssignment.estimatedTrailerSpaceRemaining} / ${driverAssignment.trailer.maxSkid}`}</div>
          </div>
          <div>
            <IconButton
              aria-expanded={expanded}
              aria-label="show more"
              className={clsx(classes.expand, {
                [classes.expandOpen]: this.state.expanded,
              })}
              onClick={() => this.openDriver(expanded)}
            >
              <ExpandMoreIcon />
            </IconButton>
          </div>
        </div>
        <div className={classes.assignedPickup}>
          <Collapse
            in={expanded}
            timeout="auto"
            unmountOnExit
            className="customScroll"
          >
            {driverAssignment.stops.map((stop, index) => {
              return stop.isVirtualStop ? (
                <PickupInfo
                  stopDetails={stop}
                  key={index}
                  classes={classes}
                  isSelected={selectedPickupId.includes(stop.pickupId.toLowerCase())}
                  color={driverAssignment.color}
                  onPickupSelection={onPickupSelection}
                />
              ) : (
                ""
              );
            })}
          </Collapse>
        </div>
      </div>
    );
  }
}
export default SolutionInfo;
